<div *ngIf="isUnselectedAnswerVisible$ | async" class="flex w-full justify-content-center align-items-center p-1"  @fadeInOut>
  <div class="font-semibold bg-primary border-round-sm p-3">
    <p> Choisis une réponse </p>
  </div>
</div>
